module.exports = __webpack_public_path__ + "static/media/japan-cover.9ad6f64c.webp";